import React from "react";
import Slider from "react-slick";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import businessman from "../assets/business_man.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Testimonials() {
  const testimonials = [
    {
      name: "John Doe",
      feedback: "Amazing service! Highly recommend.",
      company: "Company A",
      imageUrl: businessman,
    },
    {
      name: "Jane Smith",
      feedback: "The team was professional and delivered on time.",
      company: "Company B",
      imageUrl: businessman,
    },
    {
      name: "Sam Wilson",
      feedback: "Great experience from start to finish.",
      company: "Company C",
      imageUrl: businessman,
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1500,
    adaptiveHeight: true,
  };

  return (
    <div
      id="/testimonials"
      className="bg-gradient-to-r from-indigo-400 to-purple-600 p-8"
    >
      <div className="container mx-auto text-center py-10">
        <h1 className="text-4xl font-bold mb-8 text-white">Testimonials</h1>
        <Slider {...settings}>
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white text-gray-800 p-6 rounded-lg shadow-lg flex flex-col items-center mx-auto max-w-lg"
            >
              <img
                src={testimonial.imageUrl}
                alt={testimonial.name}
                className="w-24 h-24 rounded-full mb-4"
              />
              <div className="flex items-center justify-center mb-4">
                <FaQuoteLeft className="text-indigo-500 text-2xl mr-2" />
                <p className="text-xl font-semibold">
                  "{testimonial.feedback}"
                </p>
                <FaQuoteRight className="text-indigo-500 text-2xl ml-2" />
              </div>
              <p className="text-lg font-bold">{testimonial.name}</p>
              <p className="text-md text-gray-600">{testimonial.company}</p>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
}

export default Testimonials;
